import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
//import routes from "routes";
import React, { useState, useEffect } from "react";
//import ReactGA from "react-ga4";
// Images
import { Card, CardContent, Button } from "@mui/material";
import { FIND_VOTES_BY_MUNICIPALITY, FIND_STRATEGYSWOTS_BY_MUNICIPALITY } from "queries";
import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  ThreadsShareButton,
  InstapaperShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  InstapaperIcon,
  LinkedinIcon,
  TelegramIcon,
  ThreadsIcon,
  //TwitterIcon,
  WhatsappIcon,
  XIcon,
} from "react-share";
//import { number } from "prop-types";
/* eslint-disable react/prop-types */
const SWOTpublic = ({ selectedKunta }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  //const [t] = useTranslation("common");
  const [t] = useTranslation("common");
  //console.log(selectedKunta);
  /*const [strengths, setStrengths] = useState([]);
  const [weakness, setWeakness] = useState([]);
  const [opportunities, setOpportunities] = useState([]);
  const [threats, setThreats] = useState([]);
  */
  const [strengthssaved, setStrengthssaved] = useState([]);
  const [weaknesssaved, setWeaknesssaved] = useState([]);
  const [opportunitiessaved, setOpportunitiessaved] = useState([]);
  const [threatssaved, setThreatssaved] = useState([]);
  const [votes, setVotes] = useState([]);
  //const [swots, setSwots] = useState([]);
  //const [sswots, setSswots] = useState("");
  //const [verified, setVerified] = useState(false);
  //const [submitted, setSubmitted] = useState(false);
  ////console.log(submitted);
  //const [executing, setExecuting] = useState(false);
  ////console.log(executing);
  ////console.log(setExecuting);
  const sswotssw = useQuery(FIND_STRATEGYSWOTS_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  useEffect(() => {
    let sswotss = [];
    //console.log(sswotssw);
    //let municipalitiess = [];
    if (sswotssw.data) {
      sswotss = sswotssw.data.findStrategyswotsByMunicipality;
      //setOrgans(organss);
      //console.log(sswotss);
      let stre = sswotss.filter((a) => a.swotclass === "Strength");
      setStrengthssaved(stre);
      let weak = sswotss.filter((a) => a.swotclass === "Weakness");
      setWeaknesssaved(weak);
      let oppo = sswotss.filter((a) => a.swotclass === "Opportunity");
      setOpportunitiessaved(oppo);
      let thre = sswotss.filter((a) => a.swotclass === "Threat");
      setThreatssaved(thre);
      //let secs = sswotss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setsswots(secs);
      //setSwots(sswotss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [sswotssw]);
  const handleVote = () => {
    window.confirm("Sinun on kirjauduttava voidaksesi äänestää");
  };
  const votessw = useQuery(FIND_VOTES_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  useEffect(() => {
    let votess = [];
    //console.log(votessw);
    //let municipalitiess = [];
    if (votessw.data) {
      votess = votessw.data.findVotesByMunicipality;
      //setOrgans(organss);
      //console.log(votess);
      //let secs = proposalss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setProposals(secs);
      setVotes(votess);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [votessw]);
  function voteCount(p) {
    //console.log(p);
    return votes.filter((a) => a.strategyswotid === p).length;
  }
  const shareUrl = "https://kunta.live/strategy/" + selectedKunta;
  const title = "Kunta.live";
  const divstyle = {
    backgroundColor: "white",
    borderRadius: 5,
    opacity: 0.9,
  };
  return (
    <>
      <div
        style={{
          left: "10px",
          position: "fixed",
          top: "90px",
          bottom: 0,
          height: "20px",
          color: "#C4DFE6",
          zIndex: 99,
          backgroundColor: "white",
          borderRadius: 90,
          opacity: 0.7,
        }}
        height="20px"
      >
        <div style={divstyle}>
          <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </div>
        <div style={divstyle}>
          <FacebookMessengerShareButton
            url={shareUrl}
            appId="521270401588372"
            className="Demo__some-network__share-button"
          >
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton>
        </div>
        <div style={divstyle}>
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <XIcon size={32} round />
          </TwitterShareButton>
        </div>
        <div style={divstyle}>
          <TelegramShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <TelegramIcon size={32} round />
          </TelegramShareButton>
        </div>
        <div style={divstyle}>
          <WhatsappShareButton
            url={shareUrl}
            title={title}
            separator=":: "
            className="Demo__some-network__share-button"
          >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </div>
        <div style={divstyle}>
          <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </div>
        <div style={divstyle}>
          <EmailShareButton
            url={shareUrl}
            subject={title}
            body="body"
            className="Demo__some-network__share-button"
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </div>
        <div style={divstyle}>
          <InstapaperShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <InstapaperIcon size={32} round />
          </InstapaperShareButton>
        </div>
        <div style={divstyle}>
          <ThreadsShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <ThreadsIcon size={32} round />
          </ThreadsShareButton>
        </div>
      </div>
      <MKTypography variant="h2" gutterBottom>
        {t("swot.saved")}
      </MKTypography>
      <Card style={{ marginBottom: "1rem" }}>
        <CardContent>
          <MKTypography variant="h3" gutterBottom>
            {t("swot.strengths")}
          </MKTypography>
          <Container spacing={4}>
            <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
              {strengthssaved.map((item) => (
                <Button
                  key={item.id}
                  variant="contained"
                  style={{ color: "white" }}
                  onClick={() => handleVote(item.id)}
                >
                  {item.swottext} 👍 {voteCount(item.id)}
                </Button>
              ))}
            </Grid>
          </Container>
        </CardContent>
      </Card>
      <Card style={{ marginBottom: "1rem" }}>
        <CardContent>
          <MKTypography variant="h3" gutterBottom>
            {t("swot.weaknesses")}
          </MKTypography>
          <Container spacing={4}>
            <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
              {weaknesssaved.map((item) => (
                <Button
                  key={item.id}
                  variant="contained"
                  style={{ color: "white" }}
                  onClick={() => handleVote(item.id)}
                >
                  {item.swottext} 👍 {voteCount(item.id)}
                </Button>
              ))}
            </Grid>
          </Container>
        </CardContent>
      </Card>
      <Card style={{ marginBottom: "1rem" }}>
        <CardContent>
          <MKTypography variant="h3" gutterBottom>
            {t("swot.opportunities")}
          </MKTypography>
          <Container spacing={4}>
            <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
              {opportunitiessaved.map((item) => (
                <Button
                  key={item.id}
                  variant="contained"
                  style={{ color: "white" }}
                  onClick={() => handleVote(item.id)}
                >
                  {item.swottext} 👍 {voteCount(item.id)}
                </Button>
              ))}
            </Grid>
          </Container>
        </CardContent>
      </Card>
      <Card style={{ marginBottom: "1rem" }}>
        <CardContent>
          <MKTypography variant="h3" gutterBottom>
            {t("swot.threats")}
          </MKTypography>
          <Container spacing={4}>
            <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
              {threatssaved.map((item) => (
                <Button
                  key={item.id}
                  variant="contained"
                  style={{ color: "white" }}
                  onClick={() => handleVote(item.id)}
                >
                  {item.swottext} 👍 {voteCount(item.id)}
                </Button>
              ))}
            </Grid>
          </Container>
        </CardContent>
      </Card>
    </>
  );
};

export default SWOTpublic;
